import { memo, useCallback, useContext, useEffect, useState } from 'react';
import Avatar from '../../../../../components/Avatar';
import ThemeContext from '../../../../../contexts/themeContext';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getPersonDisplayName } from 'helpers/personNameI18n';


const convertSeconde2HourMinute2 = (mins) => {
	let h = Math.floor(mins / 3600);
	let m = Math.floor((mins % 3600) / 60);
	h = h < 10 ? '0' + h : h;
	m = m < 10 ? '0' + m : m;
	return `${h}:${m}`;
};

const renderMaxTimeText = (timeInfos, t) => {
	const type = t(timeInfos?.maxWorkAvg === 'max' ? '최대' : '평균');
	switch (timeInfos.maxWorkUnit) {
		case 'h': return `${type} ${timeInfos?.maxWorkHour}H`;
		case 'd': return `${t('일')} ${type} ${timeInfos?.maxWorkHour}H`;
		case 'm': return `${t('월')} ${type} ${timeInfos?.maxWorkHour}H`;
		case 'w': return `${t('주')} ${type} ${timeInfos?.maxWorkHour}H`;
		default: return '';
	}
};

const renderDefaultTimeText = (timeInfos, t) => {
	const type = t(timeInfos?.workAvg === 'max' ? '최대' : '평균');
	switch (timeInfos.workUnit) {
		case 'h': return `${type} ${timeInfos?.workHour}H`;
		case 'd': return `${t('일')} ${type} ${timeInfos?.workHour}H`;
		case 'm': return `${t('월')} ${type} ${timeInfos?.workHour}H`;
		case 'w': return `${t('주')} ${type} ${timeInfos?.workHour}H`;
		default: return '';
	}
};

const RenderGroupUser = memo((props) => {
	const { schduleUpdate } = useContext(ThemeContext);
	const [, updateState] = useState();
	const forceUpdate = useCallback(() => updateState({}), []);
	const { t } = useTranslation();

	const { group, users, selectionRange, checkedUser, setCheckedUser } = props;
	const [isHover, setIsHover] = useState(false);
	const [timeInfos, setTimeInfos] = useState({});

	const name = getPersonDisplayName(group?.user) || '';
	const isChecked = !!checkedUser?.has(group.id);

	// 같은 부모 그룹 내 마지막 유저인지 확인
	const siblings = (users || []).filter(u => u.userId && u.parent === group.parent);
	const isLast = siblings.length === 0 || siblings[siblings.length - 1]?.id === group.id;

	const getSchduleTime = (user) => {
		const startOfWeek = moment(selectionRange?.startDate).startOf('isoWeek');
		const endOfWeek = moment(selectionRange?.endDate).endOf('isoWeek');

		const thisGroup = users.find((v) => v?.id === user.parent);
		const mySchdule = schduleUpdate?.filter((v) => v.group == user.userId)
			?.filter((v) => moment(v['start_time']).isSameOrAfter(startOfWeek) && moment(v['end_time']).isSameOrBefore(endOfWeek));
		const displayMySchdule = schduleUpdate?.filter((v) => v.group == user.userId)
			?.filter((v) => moment(v['start_time']).isSameOrAfter(moment(selectionRange.startDate)) && moment(v['end_time']).isSameOrBefore(moment(selectionRange.endDate)));

		let result = { ...thisGroup?.workSystem, time: 0 };
		if (group.workType === 'flex') result.workSystem = { workAvg: 'avg' };

		const time = calculateScheduleTime(mySchdule);
		const displayTime = calculateScheduleTime(displayMySchdule);

		const workSum = time?.work?.length > 0 ? time.work.reduce((a, b) => a + b, 0) : 0;
		const restSum = time?.rest?.length > 0 ? time.rest.reduce((a, b) => a + b, 0) : 0;
		const displayWorkSum = displayTime?.work?.length > 0 ? displayTime.work.reduce((a, b) => a + b, 0) : 0;
		const displayRestSum = displayTime?.rest?.length > 0 ? displayTime.rest.reduce((a, b) => a + b, 0) : 0;

		const diffDays = endOfWeek.diff(startOfWeek, 'days') + 1;
		const weekCount = Math.ceil(diffDays / 7);

		if ((result?.workSystem?.workAvg || 'sum') === 'avg') {
			result = { ...result, group: result, time: (workSum / time?.work?.length || 0) - (restSum / time?.rest?.length || 0), displayTime: (displayWorkSum / displayTime?.work?.length || 0) - (displayRestSum / displayTime?.rest?.length || 0), weekCount };
		} else {
			result = { ...result, group: result, time: workSum - restSum, displayTime: displayWorkSum - displayRestSum, weekCount };
		}
		return result;
	};

	function calculateScheduleTime(scheduleList) {
		return scheduleList?.length > 0 ? scheduleList.reduce((pre, cur) => {
			let restTimeSeconds = 0;
			if (cur.row.type !== 'REST' && cur.row.type !== 'REST_CUSTOM' && cur.row.type !== 'REST_SCHDULE' && cur.row.type !== 'DAYOFF' && cur.row.type !== 'deducted' && !cur.id.includes('delete')) {
				if (!cur?.row?.restAuto) {
					if (cur.title === '탄력근무' || cur.title === '시차출퇴근') {
						if (cur.row?.group?.restTime?.length > 0 && cur.row?.group?.restTime[moment(cur.start_time).format('E') - 1][0][0] !== '') {
							pre.rest.push(Math.floor(moment(cur.end_time).diff(moment(cur.start_time), 'second') / (270 * 60)) * (30 * 60));
						}
					} else {
						if (cur.row?.restTime?.length > 0 && cur.row?.restTime[moment(cur.start_time).format('E') - 1][0][0] !== '') {
							cur.row?.restTime[moment(cur.start_time).format('E') - 1].forEach(times => {
								if (times[0] !== '') {
									const stime = moment(cur.start_time).format('HH:mm');
									const etime = moment(cur.end_time).format('HH:mm');
									const restInWorkTime = (moment(stime, 'HH:mm').isSame(moment(times[0], 'HH:mm')) || moment(times[0], 'HH:mm').isBetween(moment(stime, 'HH:mm'), moment(etime, 'HH:mm'))) && (moment(etime, 'HH:mm').isSame(moment(times[1], 'HH:mm')) || moment(times[1], 'HH:mm').isBetween(moment(stime, 'HH:mm'), moment(etime, 'HH:mm')));
									restTimeSeconds = restInWorkTime ? moment(times[1], 'HH:mm').diff(moment(times[0], 'HH:mm'), 'seconds') : 0;
									pre.rest.push(restTimeSeconds);
								}
							});
						} else {
							const startInData = moment(moment.isMoment(cur.start_time) ? cur.start_time.format('YYYY-MM-DD HH:mm') : cur.start_time);
							const endInData = moment(moment.isMoment(cur.end_time) ? cur.end_time.format('YYYY-MM-DD HH:mm') : cur.end_time);
							restTimeSeconds = Math.floor(moment.duration(endInData.diff(startInData)).asSeconds() / (270 * 60)) * (30 * 60);
							pre.rest.push(restTimeSeconds);
						}
					}
				}
				pre.work.push(parseInt(moment(cur.end_time).diff(moment(cur.start_time), 'second')));
			}
			return pre;
		}, { work: [], rest: [], over: [] }) : { work: [], rest: [], over: [] };
	}

	useEffect(() => {
		setTimeInfos(getSchduleTime(group));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [group, users, selectionRange, schduleUpdate]);

	const isOverTime = (timeInfos?.time || 0) > (52 * (timeInfos.weekCount || 1)) * 60 * 60;
	const displayLabel = timeInfos?.workSystem?.workAvg === 'avg' ? t('common.average') : t('adminMode.mainpage.total');


	if (group?._hidden) return <div className='rct-user-row-hidden' />;

	return (
		<div className='ws-user-row'>

			{/* 트리 커넥터 */}
			<div className='ws-tree-col'>
				<div className='ws-tree-v-line' style={{ bottom: isLast ? '50%' : 0 }} />
				<div className='ws-tree-h-line' />
			</div>

			{/* 아바타 (hover 시 숨김) */}
			{!isHover && (
				<Avatar
					textSizeRatio={0.2}
					size={26}
					style={{ flexShrink:0 }}
					className='justify-content-center align-items-center'
					userName={name}
					src={group?.user?.profile || ''}
					srcSet={group?.user?.profile || ''}
				/>
			)}

			{/* 이름 (hover 시 숨김) */}
			{!isHover && (
				<span className='ws-user-name'>{name}</span>
			)}

			{/* 합계 + 시간 + hover 시 기본/최대 정보 */}
			<div
				style={{ display:'flex', alignItems:'center', flex: isHover ? 1 : 0, flexShrink:0, cursor:'default', marginLeft: isHover ? 8 : 0, marginRight:8, gap:8 }}
				onMouseOver={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
			>
				<div className='ws-time-label'>
					<div className='ws-time-display-label'>{displayLabel}</div>
					<div style={{ fontSize:'0.93rem', fontWeight:700, color: isOverTime ? '#ef4444' : '#1e293b', lineHeight:1.3 }}>
						{convertSeconde2HourMinute2(timeInfos?.displayTime || 0)}
					</div>
				</div>
				{isHover && (
					<>
						<div className='ws-time-divider' />
						<div className='ws-time-info-detail'>
							<div>{t('기본')}: {renderDefaultTimeText(timeInfos, t)}</div>
							<div>{t('최대')}: {renderMaxTimeText(timeInfos, t)}</div>
						</div>
					</>
				)}
			</div>

			{/* 원형 체크박스 */}
			{!!checkedUser && (
				<div
					className='ws-user-checkbox'
					style={{
						border: isChecked ? 'none' : '1.5px solid #cbd5e1',
						background: isChecked ? '#4f46e5' : 'transparent',
					}}
					onClick={(e) => {
						e.stopPropagation();
						setCheckedUser(prev => {
							const next = new Set(prev);
							isChecked ? next.delete(group.id) : next.add(group.id);
							return next;
						});
					}}
				>
					{isChecked && (
						<svg width='9' height='9' viewBox='0 0 12 12' fill='none'>
							<path d='M2 6l3 3 5-5' stroke='white' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'/>
						</svg>
					)}
				</div>
			)}
		</div>
	);
});

export default RenderGroupUser;
